import cn from 'classnames';
import { MouseEvent } from 'react';

import styles from './Accordion.module.scss';
import { useAccordionContext, useAccordionItemContext } from './context';
import { AccordionButtonProps } from './types';

export const AccordionButton = ({ children, className, onClick, ...props }: AccordionButtonProps) => {
    const { toggleItem, Icon, isIconVisible, variant } = useAccordionContext();
    const { itemId, buttonId, panelId, expanded } = useAccordionItemContext();

    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        onClick?.(event);

        if (!event.defaultPrevented) {
            toggleItem(itemId);
        }
    };

    return (
        <button
            type="button"
            id={buttonId}
            className={cn(styles.button, className)}
            aria-expanded={expanded}
            aria-controls={panelId}
            onClick={handleClick}
            {...props}
        >
            {children}
            {Icon && isIconVisible && (
                <Icon
                    aria-hidden
                    className={cn(
                        styles.icon,
                        expanded && (variant === 'links' ? styles.icon_linksExpanded : styles.icon_defaultExpanded)
                    )}
                />
            )}
        </button>
    );
};
